const data = [
    {
        ques: 'What is Love?',
        ans: 'Love is when two people touch each other\'s soul. Love is honesty and trust. Love is helping one another. Love is mutual respect. Love means that differences can be worked out. Love is reaching your dreams together. Love is the connection of two hearts.'
    },
    {
        ques: 'Why Ice floats on Water?',
        ans: 'What\'s so special about ice that causes it to float? Believe it or not, ice is actually about 9% less dense than water. Since the water is heavier, it displaces the lighter ice, causing the ice to float to the top'
    },
    {
        ques: 'How is Shehnai different from Pungi?',
        ans: 'Shehnai is an improved version of pungi as it has a better tonal quality than pungi. It is a natural hollow stem pipe that is longer and broader than a pungi. It has seven holes on the body of the pipe.'
    },
    {
        ques: 'Was there life on Mars?',
        ans: `To date, no proof of past or present life has been found on Mars. Cumulative evidence suggests that during the ancient Noachian time period, the surface environment of Mars had liquid water and may have been habitable for microorganisms, but habitable conditions do not necessarily indicate life.`
    },
    {
        ques: 'Why is Muharram Celebrated?',
        ans: `Muharram is observed by Shia Muslims to commemorate the martyrdom of Prophet Mohammed's grandson, Hazrat Imam Hussain, who was killed in the battle of Karbala in 680 A.D. The prophet's son-in-law, Ali, and Ali's elder son, Hassan, are also remembered during this period as having suffered and died for a righteous cause.`
    }
]

export default data;